'use strict';

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var _require = require('./symbols'),
    numberToPermissionLookup = _require.numberToPermissionLookup,
    permissionToNumberLookup = _require.permissionToNumberLookup,
    CAN_READ = _require.CAN_READ,
    CAN_WRITE = _require.CAN_WRITE,
    CAN_EDIT = _require.CAN_EDIT,
    CAN_ADMINISTER = _require.CAN_ADMINISTER;

var _require2 = require('./endpoints'),
    contributorSearchEndpoint = _require2.contributorSearchEndpoint,
    sendInvitationEndpoint = _require2.sendInvitationEndpoint;

var Contributor = function () {
  function Contributor(attributes) {
    (0, _classCallCheck3.default)(this, Contributor);
    this.attributes = attributes;
    this.client = attributes.client;
  }

  (0, _createClass3.default)(Contributor, [{
    key: 'resendInvitation',
    value: function () {
      var _ref2 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee(_ref) {
        var privacyPolicyId = _ref.privacyPolicyId;
        return _regenerator2.default.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return this.client.post(sendInvitationEndpoint({
                  privacyPolicyId: privacyPolicyId
                }), {
                  invite_user_id: this.userId
                });

              case 2:
                this._isInvitationSent = true;
                return _context.abrupt('return', true);

              case 4:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function resendInvitation(_x) {
        return _ref2.apply(this, arguments);
      }

      return resendInvitation;
    }()
  }, {
    key: 'email',
    get: function get() {
      return this.attributes.email;
    }
  }, {
    key: 'userId',
    get: function get() {
      return this.attributes.id;
    }
  }, {
    key: 'username',
    get: function get() {
      return this.attributes.username;
    }
  }, {
    key: 'name',
    get: function get() {
      return this.attributes.name;
    }
  }, {
    key: 'avatar',
    get: function get() {
      return this.attributes.avatar || 'https://resources.padletcdn.com/avatars/alien1.png';
    }
  }, {
    key: 'shortName',
    get: function get() {
      return this.attributes.short_name || this.attributes.shortName;
    }
  }, {
    key: 'right',
    get: function get() {
      return this.attributes.right || this.attributes.access;
    }
  }, {
    key: 'permission',
    get: function get() {
      return numberToPermissionLookup(this.attributes.right || this.attributes.access);
    },
    set: function set(newPerm) {
      if (typeof newPerm !== 'string') {
        console.error(newPerm + ' should be a string');
      } else if ([CAN_READ, CAN_WRITE, CAN_EDIT, CAN_ADMINISTER].indexOf(newPerm) < 0) {
        console.error(newPerm + ' not an allowed permission');
      } else {
        this.attributes.right = permissionToNumberLookup(newPerm);
        this.attributes.access = this.attributes.right;
      }
    }
  }, {
    key: 'canRead',
    get: function get() {
      return this.permission === CAN_READ;
    },
    set: function set(newVal) {
      if (newVal === true) this.permission = CAN_READ;
    }
  }, {
    key: 'canWrite',
    get: function get() {
      return this.permission === CAN_WRITE;
    },
    set: function set(newVal) {
      if (newVal === true) this.permission = CAN_WRITE;
    }
  }, {
    key: 'canEdit',
    get: function get() {
      return this.permission === CAN_EDIT;
    },
    set: function set(newVal) {
      if (newVal === true) this.permission = CAN_EDIT;
    }
  }, {
    key: 'canAdminister',
    get: function get() {
      return this.permission === CAN_ADMINISTER;
    },
    set: function set(newVal) {
      if (newVal === true) this.permission = CAN_ADMINISTER;
    }
  }, {
    key: 'isInvitationSent',
    get: function get() {
      if (typeof this._isInvitationSent === 'undefined') {
        this._isInvitationSent = false;
      }

      return this._isInvitationSent;
    }
  }]);
  return Contributor;
}();

var searchContributors = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(client, usernameOrEmail) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var jsonResult, basePerm;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.next = 2;
            return client.get(contributorSearchEndpoint((0, _extends3.default)({
              query: usernameOrEmail
            }, options)));

          case 2:
            jsonResult = _context2.sent;
            basePerm = options.defaultPermission || CAN_READ;
            return _context2.abrupt('return', (jsonResult || []).map(function (_ref4) {
              var username = _ref4.username,
                  avatar = _ref4.avatar,
                  name = _ref4.name,
                  shortName = _ref4.shortName,
                  short_name = _ref4.short_name,
                  id = _ref4.id;
              return new Contributor({
                right: permissionToNumberLookup(basePerm),
                client: client,
                // so we can resend invitations
                id: id,
                // user ID
                short_name: short_name,
                shortName: shortName,
                username: username,
                avatar: avatar,
                name: name
              });
            }));

          case 5:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function searchContributors(_x3, _x4) {
    return _ref3.apply(this, arguments);
  };
}();

module.exports = {
  Contributor: Contributor,
  searchContributors: searchContributors
};